module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type === 'box') ? _c('EquipmentBoxBrain') : (_vm.type === 'box-venue') ? _c('EquipmentBoxVenueBrain') : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ca77dee6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UniversityManage/EquipmentManage/EquipmentList/EquipmentBrain.vue
// module id = 1126
// module chunks = 0